// extracted by mini-css-extract-plugin
export default {"customHeading":"dataDisplay_customHeading__ohhlj","customContent":"dataDisplay_customContent__GgtoX"};